import classNames from 'classnames';
import React from 'react';
import { useI18n, LocalizedHtml } from '@udemy/i18n';
import { Image } from '@udemy/react-core-components';
import styles from "./pro-certification-badge.module.css";
export const badgeImageSizes = {
  small: {
    width: 24,
    height: 24
  },
  large: {
    width: 40,
    height: 40
  }
};
export const badgeTextSizes = {
  small: 'ud-text-xs',
  large: 'ud-text-md'
};
export const ProCertificationBadge = ({
  badge,
  size = 'small'
}) => {
  const imageSize = badgeImageSizes[size];
  const textSize = badgeTextSizes[size];
  const {
    gettext,
    interpolate
  } = useI18n();
  const badgeName = badge === null || badge === void 0 ? void 0 : badge.name;
  const CuratedByUBPro = () => {
    return /*#__PURE__*/React.createElement(LocalizedHtml, {
      className: classNames(textSize, styles['pro-cert-badge-text']),
      html: gettext('Curated by <span class="ubProBold">Udemy Business Pro</span>'),
      interpolate: {
        ubProBold: /*#__PURE__*/React.createElement("span", {
          className: "ud-text-bold"
        })
      }
    });
  };
  const CuratedForBadgeName = () => {
    return /*#__PURE__*/React.createElement(LocalizedHtml, {
      className: classNames(textSize, styles['pro-cert-badge-text']),
      html: interpolate(gettext('Curated for <span class="badgeNameBold">%(badgeName)s</span>'), {
        badgeName
      }, true),
      interpolate: {
        badgeNameBold: /*#__PURE__*/React.createElement("span", {
          className: "ud-text-bold"
        })
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['pro-cert-badge-container'], size === 'small' ? styles['pro-cert-badge-container-small'] : styles['pro-cert-badge-container-large'])
  }, badge ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, Object.assign({
    "data-test-id": "badge-image",
    src: badge.image.id,
    alt: badge.name
  }, imageSize)), /*#__PURE__*/React.createElement(CuratedForBadgeName, null)) : /*#__PURE__*/React.createElement(CuratedByUBPro, null));
};
ProCertificationBadge.displayName = 'ProCertificationBadge';
//# sourceMappingURL=pro-certification-badge.react-component.js.map